import React, {useState, forwardRef, useImperativeHandle, useRef, useEffect} from 'react';
import Props from 'prop-types';
import { post } from '../../../../../../Model/Network/Config/Axios';
import { useSelector } from 'react-redux';
import _ from 'lodash';

const SearchEntity = forwardRef(({disabled=false, style,gstin,category,onSelect,extra={},entityName='',bill_To={} }, ref) => {

    const [suggestion, setSuggestion] = useState([]);
    const [value, setValue] = useState(undefined);
    const companyList1 = ["PIRAMAL","prml"]
    const companyList2 = ['FMLOG']
    const companyList3 = ['TESTASK','ASK']
    const companyList4 = ['STELMC','STELMEC',]
    const {costAllocationCustomTableColumn,costAllocationCustomTableId,costAllocationType,searchFields,tenant,filterKey,plugins} = useSelector(state=>state.auth.config);
    const {entityWiseFilter}= plugins
 

    let VALUE=useRef();

    useEffect(()=>{
        if (value && value.length > 0) {

            let data = {
                searchField:searchFields,
                q:value,
                ...extra
            }

            if(_.includes(companyList4,tenant)) {
                if(bill_To && bill_To['customTags'] && bill_To['customTags']['branch_abbrv']) {
                    data = {
                        ...data,
                        data:{
                            branch_abbrv:bill_To['customTags']['branch_abbrv']
                        }
                    }
                }
            }
            if(_.includes(companyList1,tenant)) {
                if(filterKey &&gstin) {
                    data = {
                        ...data,
                        data:{
                            gstin
                        }
                    }
                }
            }

            if(_.includes(companyList2,tenant)) {
                if(filterKey &&gstin) { 
                    data ={
                        ...data,
                        data:{
                            category
                        }
                    }
                }
            }
            if(_.includes(companyList3,tenant)) {
                if(entityWiseFilter && filterKey && (filterKey==='entity') && entityName) {
                    const match = entityName.match(/\(([^)]+)\)/);
                    
                    const entity = match && match[1] ? match[1] : entityName;
                    data = {
                        ...data,
                        data:{
                            entity:entity||''
                        }
                    }
                }
               
            }
            post(`forms/searchTable/${costAllocationCustomTableId}`,data,(e,r)=>{
                if(r) {
                    setSuggestion(r.results.map(item=>{
                        delete item["_id"]
                        return {
                            ...item,
                            name:item[costAllocationCustomTableColumn],
                        }
                    }));
                }
            })
        } else {
            setSuggestion([]);
        }
    },[value])

    const onChange = (e) => {
        setValue(e.target.value);
    }

    const suggestionList = (item, index) => {
        return (
            <div key={index}
                onClick={() => {
                    setSuggestion([]);
                    if(onSelect) {
                        onSelect(item.name);
                    }
                    setValue(item);
                    VALUE.current.value =item.name;
                }}
                className="flex flex-v-center hover"
                style={{
                    minHeight: 45,
                    paddingLeft: 20,
                    cursor: 'pointer',
                    color: 'var(--input-color)',
                    borderBottom:'1px solid var(--border-color)'
                }}>
                <div>
                {
                        Object.keys(item).sort((a, b) => a.localeCompare(b)).map((i,j)=>{
                            if(i==='name' || i==='gstin') {
                               return <div key={j} />
                            }
                            return(
                                <div key={j}>
                                    {i} : {item[i]}
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        )
    }

    useImperativeHandle(ref, () => ({
        getValue: () => {
            return value;
        }
    }));

    return (
        <div style={{
            marginBottom: 20,
            ...style
        }}>
            <p style={{
                color: 'var(--title-desc-color)',
                fontSize: 15
            }}>
                Search {costAllocationType}
            </p>

            <div style={{
                position: 'relative'
            }}>
                <div className="flex flex-h-center flex-v-center" style={{
                    borderRadius: 8,
                    height: 50,
                    marginTop: 10,
                    cursor: 'pointer',
                    border:'1px solid var(--border-color)'
                }}>
                    <input 
                        disabled={disabled}
                        style={{
                            width: '98%',
                            height: '90%',
                            backgroundColor: '#fff',
                            color: 'var(--input-color)',
                            fontSize: 16,
                            padding: '10px 12px',
                            border: 'none'
                        }}
                        ref={VALUE}
                        onChange={onChange}
                        placeholder={`Search ${costAllocationType}`}
                    />
                </div>
                {
                    suggestion.length > 0 ?
                        <div style={{
                            position: 'absolute',
                            height: 210,
                            overflowY: 'auto',
                            width: '100%',
                            top: 53,
                            paddingTop: 10,
                            paddingBottom: 10,
                            boxShadow: '0px 0px 5px 1px var(--input-backgroundColor)',
                            zIndex: 10,
                            border:'1px solid var(--border-color)',
                            backgroundColor:'#fff'

                        }}>
                            {suggestion.map(suggestionList)}
                        </div> :
                        null
                }
            </div>
        </div>
    )
})


SearchEntity.propsTypes = {
    type: Props.string
}

SearchEntity.defaultProps = {
    type: 'text',
    placeholder: 'Enter the Text',
}


export {SearchEntity}

export default SearchEntity ;
